exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".alfa_transfers-container {\n  padding-bottom: 75px;\n  margin: 24px 18px;\n  font-family: \"Proxima Nova Regular\", sans-serif;\n  font-size: 18px;\n  font-weight: normal; }\n  .alfa_transfers-container b {\n    color: #ef3124;\n    font-size: 20px;\n    font-family: 'Proxima Nova Bold', sans-serif;\n    margin-bottom: 6px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/AlfaTransfers/AlfaTransfersPageContainer.scss
// module id = 412
// module chunks = 0